<template>
  <div class="examCheckDetail">
    <div class="UserList">
      <div class="topItem">
        <div class="itemOne">考试列表</div>
        <div class="itemTwo" @click="GobackPath">返回试卷列表</div>
      </div>
      <div class="middleItem">
        <div class="box">
          <div class="card col1"></div>
          <div class="txt">已阅卷</div>
        </div>
        <div class="box">
          <div class="card col2"></div>
          <div class="txt">阅卷中</div>
        </div>
        <div class="box">
          <div class="card col3"></div>
          <div class="txt">未阅卷</div>
        </div>
      </div>
      <div class="botItem">
        <div
          v-for="(v, index) in examCheckUser"
          :key="index"
          class="userBox"
          @click="GoCurrentQues(index, v)"
        >
          <div v-if="currentIndex == index">
            <div class="userCard1">{{ index + 1 }}</div>
          </div>
          <div v-else>
            <!-- state: 1-未阅卷 2-阅卷中 3-已完成 -->
            <div v-if="v.state == 3" class="userCard">{{ index + 1 }}</div>
            <div v-else-if="v.state == 2" class="userCard2">{{ index + 1 }}</div>
            <div v-else>{{ index + 1 }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="mainBox">
      <div class="subCard">
        <div class="subtitle">第{{ currentIndex + 1 }}号考生</div>
        <el-button class="nextBtn" :disabled="disabledBtn" @click="handlesubmitMark">{{
          txtBtn
        }}</el-button>
      </div>
      <div class="quesTionList">
        <div v-for="(v, key) in questionMaps" :key="key" class="quesBox">
          <div class="itemLeft">
            <div class="itemOne">
              <div class="typeQues">
                【{{ typeMap[v.questionType - 1].name }}】<span>本题{{ v.score }}分</span>
              </div>
              <div class="scroeGet">
                <p>得分：</p>
                <el-input
                  v-model="v.realScore"
                  class="scoreInput"
                  clearable
                  @keyup.native="v.realScore = inputNumber(v.realScore, v.score)"
                  @click.native="selectValue($event)"
                ></el-input>
              </div>
            </div>
            <div class="itemTwo">
              <div class="currentQues">{{ key + 1 }}.</div>
              <!-- eslint-disable-next-line vue/no-v-html -->
              <div class="quesName" v-html="v.questionName">
                <!-- 双卡双待科举时代开始就第四季度流口水的十大科技深刻地揭示了快点结束了肯定就是上课的建设靠大家上课 -->
              </div>
            </div>
            <div class="itemThr">
              <div
                v-if="v.questionType != 1 || v.questionType != 2 || v.questionType != 4"
                class="Anwser"
              >
                <div class="subTxt">【考生答案】</div>
                <!-- eslint-disable-next-line vue/no-v-html -->
                <div class="userAnwser" v-html="v.userAnswer"></div>
              </div>
            </div>
            <div v-if="[4845].includes(userInfo.id)"></div>
            <div v-else class="itemThr">
              <div
                v-if="v.questionType != 1 || v.questionType != 2 || v.questionType != 4"
                class="Anwser"
              >
                <div class="subTxt">扣分原因</div>
                <!-- eslint-disable-next-line vue/no-v-html -->
                <tinymce ref="editor" v-model="v.comment" height="170" width="783"></tinymce>
                <div class="submitComment">
                  <el-button type="primary" @click="handleSubmitComment(v)">保存</el-button>
                </div>
              </div>
            </div>
          </div>
          <div class="itemRight">
            <div class="systemAnwser">
              <div class="subSysAnwser">【标准答案】</div>
              <!-- eslint-disable-next-line vue/no-v-html -->
              <div class="sysAnwser" v-html="v.rightAnswer"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import to from 'await-to'
import {
  examMarkUserList,
  examMarkCheckDetail,
  submitMarkscore,
  examCheckCommentSubmit,
} from '@/api/exam'
import { userIsSuper } from '@/api/login'
import Tinymce from '@/components/Tinymce'
import { mapGetters } from 'vuex'
import { stopRecording } from '@/utils/screenRecord'
export default {
  components: { Tinymce },
  data() {
    return {
      subjectId: this.$route.query.subjectId || '',
      paperId: this.$route.query.paperId || '',
      planId: this.$route.query.planId || '',
      examCheckUser: [{}],
      currentIndex: 0,
      questionMaps: [],
      extendData: {},
      form: '',
      typeMap: [
        { name: '单选题' },
        { name: '多选题' },
        { name: '计算题' },
        { name: '判断题' },
        { name: '填空题' },
        { name: '简答题' },
        { name: '论述题' },
        { name: '案例分析题' },
        { name: '综合题' },
      ],
      txtBtn: '完成阅卷下一个考生',
      disabledBtn: false,
      isSuper: false,
    }
  },
  computed: {
    ...mapGetters(['userInfo']),
  },
  mounted() {
    this.handleGetExamMarkUserList()
    this.handleIsSuper()
  },
  methods: {
    async handleSubmitComment(record) {
      const [, err] = await to(
        examCheckCommentSubmit({
          recordId: record.recordId,
          questionId: record.questionId,
          comment: record.comment,
        }),
      )
      if (err) return this.$message.warning(err.msg)
      this.$message.success('保存成功')
    },
    async handleIsSuper() {
      const [res, err] = await to(userIsSuper({}))
      if (err) return this.$message.warning(err.msg)
      this.isSuper = res.data
    },
    GobackPath() {
      this.$router.push('/exam/mark')
    },
    async handleGetExamMarkUserList() {
      const [res, err] = await to(
        examMarkUserList({ paperId: this.paperId, planId: this.planId, subjectId: this.subjectId }),
      )
      if (err) return this.$message.warning(err.msg)
      this.examCheckUser = res.data
      if (res.data) {
        this.handleGetExamMarkDetail(res.data[0].id)
      }
    },
    async handleGetExamMarkDetail(examUserId) {
      const [res, err] = await to(
        examMarkCheckDetail({
          paperId: this.paperId,
          examUserId: examUserId,
          subjectId: this.subjectId,
        }),
      )
      if (err) return this.$message.warning(err.msg)
      this.extendData = res.extendData
      this.questionMaps = res.data
      for (let i of this.questionMaps) {
        this.$set(i, 'realScore', i.userScore)
      }
    },
    GoCurrentQues(index, row) {
      this.currentIndex = index
      this.handleGetExamMarkDetail(row.id)
      if (this.currentIndex < this.examCheckUser.length - 1) {
        this.txtBtn = '完成阅卷下一个考生'
      }
      if (this.currentIndex == this.examCheckUser.length - 1) {
        this.txtBtn = '完成阅卷'
      }
    },
    async handlesubmitMark() {
      this.disabledBtn = true
      setTimeout(() => {
        this.disabledBtn = false
      }, 1000)
      let examUserId = this.examCheckUser[this.currentIndex].id
      let userId = this.examCheckUser[this.currentIndex].userId
      let paperId = this.paperId
      let planId = this.planId
      let subjectId = this.subjectId
      let recordId = this.questionMaps[0].recordId
      let arry = []
      this.questionMaps.forEach(item => {
        let obj = {
          questionId: item.questionId,
          score: item.realScore,
          comment: item.comment,
        }
        arry.push(obj)
      })
      const [, err] = await to(
        submitMarkscore({
          examUserId: examUserId,
          paperId: paperId,
          planId: planId,
          recordId: recordId,
          subjectId: subjectId,
          userId: userId,
          userQuestionScores: arry,
        }),
      )
      if (err) return this.$message.warning(err.msg)
      this.$message.success('阅卷成功')
      this.currentIndex += 1
      if (this.currentIndex == this.examCheckUser.length - 1) {
        this.txtBtn = '完成阅卷'
      } else if (this.currentIndex == this.examCheckUser.length) {
        // 完成所有阅卷，结束屏幕录制并自动下载视频
        stopRecording()
        this.GobackPath()
      }
      // if (this.currentIndex < this.examCheckUser.length - 1) {
      //   this.currentIndex = this.currentIndex + 1
      // }
      // if (this.currentIndex == this.examCheckUser.length - 1) {
      //   this.txtBtn = '完成阅卷'
      //   this.GobackPath()
      // }
      const [res, error] = await to(
        examMarkUserList({ paperId: this.paperId, planId: this.planId, subjectId: this.subjectId }),
      )
      if (error) return this.$message.warning(error.msg)
      this.examCheckUser = res.data
      if (res.data) {
        this.handleGetExamMarkDetail(this.examCheckUser[this.currentIndex].id)
      }
    },
    //效验输入框
    inputNumber(num, maxScore) {
      let str = num.toString()
      var len1 = str.substr(0, 1)
      var len2 = str.substr(1, 1)
      //如果第一位是0，第二位不是点，就用数字把点替换掉
      if (str.length > 1 && len1 == 0 && len2 != '.') {
        str = str.substr(1, 1)
      }
      if (len1 == '.') {
        str = ''
      }
      //正则替换
      str = str.replace(/[^0-9]/g, '') // 保留数字和小数点
      if (Number(str - 0) > Number(maxScore - 0)) {
        this.$message.warning('分值不能大于题目总分值')
        return
      } else {
        return str
      }
    },
    selectValue(e) {
      e.target.select()
    },
  },
}
</script>
<style scoped lang="scss">
.examCheckDetail {
  display: flex;
  .UserList {
    width: 290px;
    background: #ffffff;
    margin-bottom: 20px;
    flex-shrink: 0;
    .topItem {
      height: 60px;
      display: flex;
      justify-content: space-between;
      border-bottom: 1px solid #ebeef5;
      .itemOne {
        font-size: 16px;
        font-family: Source Han Sans CN-Medium, Source Han Sans CN;
        font-weight: 500;
        color: #4d4d4d;
        line-height: 60px;
        padding-left: 20px;
      }
      .itemTwo {
        margin-top: 12px;
        margin-right: 10px;
        width: 100px;
        height: 36px;
        border-radius: 4px 4px 4px 4px;
        opacity: 1;
        border: 1px solid #3671bf;
        font-size: 14px;
        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
        font-weight: 400;
        color: #3671bf;
        text-align: center;
        line-height: 36px;
        cursor: pointer;
      }
    }
    .middleItem {
      margin: 20px 26px 0 20px;
      padding-bottom: 20px;
      border-bottom: 1px solid #ebeef5;
      display: flex;
      justify-content: space-between;
      .box {
        display: flex;
        .card {
          width: 20px;
          height: 14px;
          border-radius: 2px 2px 2px 2px;
        }
        .txt {
          font-size: 14px;
          font-family: Source Han Sans CN-Regular, Source Han Sans CN;
          font-weight: 400;
          color: #333333;
          line-height: 16px;
          padding-left: 4px;
        }
        .col1 {
          background: #e4eaf2;
        }
        .col2 {
          background: #3671bf;
        }
        .col3 {
          background: #ffffff;
          border: 1px solid #e6e8ed;
        }
      }
    }
    .botItem {
      margin-top: 4px;
      padding-left: 20px;
      padding-right: 26px;
      // display: flex;
      // flex-wrap: wrap;
      display: grid;
      grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
      .userBox {
        width: 36px;
        height: 28px;
        border-radius: 4px 4px 4px 4px;
        opacity: 1;
        border: 1px solid #e6e8ed;
        font-size: 16px;
        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
        font-weight: 400;
        color: #606266;
        line-height: 28px;
        text-align: center;
        margin-top: 16px;
        margin-right: 13px;
        cursor: pointer;
        // &:nth-child(5n) {
        //   margin-right: 0px;
        // }
        .userCard {
          background: #e4eaf2;
          color: #3671bf;
        }
        .userCard1 {
          background: #3671bf;
          color: #ffffff;
        }
        // 阅卷中
        .userCard2 {
          background: #3671bf;
          color: #ffffff;
        }
      }
    }
  }
  .mainBox {
    width: 100%;
    margin-left: 20px;
    margin-bottom: 20px;
    .subCard {
      height: 60px;
      // border: 1px solid #eceef2;
      display: flex;
      justify-content: space-between;
      background: #ffffff;
      .subtitle {
        font-size: 18px;
        font-family: Source Han Sans CN-Medium, Source Han Sans CN;
        font-weight: 500;
        color: #333333;
        line-height: 60px;
        padding-left: 20px;
      }
      .nextBtn {
        width: 150px;
        height: 36px;
        background: #3671bf;
        border-radius: 4px 4px 4px 4px;
        font-size: 14px;
        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
        font-weight: 400;
        color: #ffffff;
        line-height: 36px;
        text-align: center;
        margin-top: 12px;
        margin-right: 20px;
        cursor: pointer;
      }
    }
    .quesTionList {
      margin-top: 1px;
      .quesBox {
        background: #ffffff;
        padding: 20px;
        margin-bottom: 10px;
        display: flex;
        &:last-child() {
          margin-bottom: 0px;
        }
        .itemLeft {
          width: 840px;
          .itemOne {
            height: 60px;
            background: #f5f7fa;
            display: flex;
            justify-content: space-between;
            .typeQues {
              font-size: 16px;
              font-family: Source Han Sans CN-Bold, Source Han Sans CN;
              font-weight: bold;
              color: #3671bf;
              line-height: 60px;
              padding-left: 20px;
              span {
                font-size: 16px;
                font-family: Source Han Sans CN-Regular, Source Han Sans CN;
                font-weight: 400;
                color: #666666;
              }
            }
            .scroeGet {
              display: flex;
              margin-right: 20px;
              p {
                font-size: 16px;
                font-family: Source Han Sans CN-Regular, Source Han Sans CN;
                font-weight: 400;
                color: #333333;
                flex-shrink: 0;
                line-height: 60px;
              }
              .scoreInput {
                width: 80px;
                height: 40px;
                background: #ffffff;
                border-radius: 2px 2px 2px 2px;
                margin-top: 10px;
              }
            }
          }
          .itemTwo {
            display: flex;
            margin-top: 20px;
            .currentQues {
              font-size: 18px;
              font-family: SourceHanSansCN-Regular-, SourceHanSansCN-Regular;
              font-weight: normal;
              color: #333333;
              line-height: 28px;
            }
            .quesName {
              flex-wrap: wrap;
              font-size: 18px;
              font-family: SourceHanSansCN-Regular-, SourceHanSansCN-Regular;
              font-weight: normal;
              color: #333333;
              line-height: 28px;
              margin-left: 10px;
              white-space: normal;
              word-break: break-all;
              overflow: hidden;
              text-align: left;
              // display: inline-block;
            }
          }
          .itemThr {
            margin-top: 30px;
            max-height: 360px;
            background: #f5f8fc;
            border-radius: 0px 0px 0px 0px;
            padding: 20px 30px 25px 20px;
            overflow-x: hidden;
            overflow-y: scroll;
            .subTxt {
              font-size: 16px;
              font-family: Source Han Sans CN-Medium, Source Han Sans CN;
              font-weight: 500;
              color: #3671bf;
              line-height: 16px;
              margin-bottom: 10px;
            }
            .userAnwser {
              font-size: 16px;
              font-family: Source Han Sans CN-Regular, Source Han Sans CN;
              font-weight: 400;
              color: #333333;
              line-height: 26px;
            }
            .submitComment {
              margin-top: 20px;
            }
          }
          .itemThr::-webkit-scrollbar {
            display: none;
          }
        }
        .itemRight {
          margin-left: 30px;
          width: 440px;

          background: #f7fcf9;
          border-radius: 0px 0px 0px 0px;
          opacity: 1;
          border: 1px solid #e4eaec;

          // padding: 20px;
          .systemAnwser {
            max-height: 631px;
            overflow-x: hidden;
            overflow-y: scroll;
            padding: 20px;
            .subSysAnwser {
              font-size: 16px;
              font-family: Source Han Sans CN-Medium, Source Han Sans CN;
              font-weight: 500;
              color: #45bb6d;
              line-height: 16px;
              margin-bottom: 10px;
            }
            .sysAnwser {
              font-size: 14px;
              font-family: Source Han Sans CN-Regular, Source Han Sans CN;
              font-weight: 400;
              color: #666666;
              line-height: 22px;
            }
          }
          .systemAnwser::-webkit-scrollbar {
            display: none;
          }
        }
      }
    }
  }
}
</style>
